import { ComponentProps } from "react";

import { TouchableOpacity } from "react-native";
import {
  Icon,
  Portal,
  Modal as PaperModal,
  useTheme,
} from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = ComponentProps<typeof PaperModal> & {
  showClose?: boolean;
};
export default function Modal({
  children,
  contentContainerStyle,
  showClose,
  ...props
}: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  return (
    <Portal>
      <PaperModal
        {...props}
        contentContainerStyle={[
          tailwind("px-12 py-8 mx-8 rounded-xl relative items-center"),
          { backgroundColor: colors.surface },
          contentContainerStyle,
        ]}
      >
        {children}
        {showClose && <CloseButton onDismiss={props.onDismiss} />}
      </PaperModal>
    </Portal>
  );
}

function CloseButton({ onDismiss }: { onDismiss: Props["onDismiss"] }) {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  if (!onDismiss) return null;
  return (
    <TouchableOpacity
      onPress={onDismiss}
      style={tailwind("rounded-full p-2 absolute top-2 right-2")}
    >
      <Icon source="close" size={24} color={colors.onSurfaceDisabled} />
    </TouchableOpacity>
  );
}
